import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { isUrsa } from "../../../../util/themeHelper";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { OptionBaseStyled } from "./OptionBaseStyled";
export const OptionBase = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    key
  } = useTheme();
  const themeMode = key;
  const optionHeight = props.height ?? isUrsa(themeMode) ? menuTheme.optionHeight.dense(themeMode) : menuTheme.optionHeight.normal(themeMode);
  return /*#__PURE__*/React.createElement(OptionBaseStyled, _extends({}, props, {
    height: optionHeight,
    themeMode: themeMode,
    ref: ref
  }));
});
OptionBase.displayName = "OptionBase";
//# sourceMappingURL=OptionBase.js.map